<script>
  import { M } from '../../external';
  import MemberAvatarSetting from './MemberAvatarSetting.svelte';

  export let name, extra;
  let avatarSetting;

  export const getAuthor = async () => {
    const avatarChangeResult = await avatarSetting.getResult();
    if (avatarChangeResult && avatarChangeResult.changed) {
      // take previous extra so we do not lose whatever was in there
      return { name, extra: { ...extra, avatar: avatarChangeResult.image } };
    }

    return { name, extra: extra };
  };
</script>

<div class="popup-widget-wrapper">
  <div class="col20 f-left mt-15">
    <div class="info">
      <h5>{M.ADMIN_AUTHOR_LABEL_NAME}</h5>
      <span>{M.ADMIN_AUTHOR_LABEL_DESC}</span>
    </div>
    <div class="right-side"><input bind:value={name} type="text" class="transition-border" /></div>
  </div>

  <MemberAvatarSetting bind:this={avatarSetting} member={{ name, extra }} />
</div>
